import React from "react";

import * as styles from "./styles.module.css";

/**
 * Renders a job card component.
 *
 * @param {object} job - The job object containing information about the job.
 * @return {JSX.Element} The rendered job card component.
 */
const JobCard = ({ job }) => {
    const detailLink = `https://jobs.jobvite.com/qlik/job/${job.id}`;

    return (
        <a href={detailLink} target="_blank" rel="noreferrer" className="group/jobcard hover:no-underline">
            <div
                key={job.id}
                className={`${styles.blogMediaCard} relative h-full border border-stone/50 bg-white rounded p-3 sm:pb-4.5 sm:pt-4.75 sm:px-4.75 flex flex-col hover:no-underline lg:hover:shadow-lg transition-shadow duration-300`}
            >
                <div>
                    <div className="tag-3 text-ocean mb-4 text-sm">{job.category}</div>

                    <h6 className="mb-4 line-clamp-4 group-hover/jobcard:underline group-hover/jobcard:underline-offset-2">
                        {job.title || job.briefDescription}
                    </h6>
                </div>
                <div className="mt-auto flex flex-col gap-5">
                    <div className="grid grid-cols-1 gap-2">
                        <div className="flex flex-col lg:flex-row justify-start gap-1 lg:gap-6">
                            {job.jobLocations &&
                                job.jobLocations.map((loc) => (
                                    <p key={loc.eId} className="text-sm">
                                        {loc.name}
                                    </p>
                                ))}
                        </div>
                    </div>
                </div>
            </div>
        </a>
    );
};

export default JobCard;
